import { ReactElement, useCallback, useEffect, useState } from "react";
import LoadingSpinner from "../shared/LoadingSpinner";
import {
  Button,
  Card,
  Grid2 as Grid,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { Item } from "../shared/Item";
import { useLocation, useNavigate } from "react-router-dom";
import { isEmpty } from "lodash";
import {
  getAllImagesList,
  updImagesActive,
} from "../../services/ImagesServices";
import { image } from "../shared/SharedInterfaces";
import ArticleImagesUploader from "./ArticleImagesUploader";
import { article } from "./ArticleInterfaces";
import { getValue } from "components/shared/CommonFunctions";
import { saveArticle } from "services/ArticleServices";

const EditArticles = (): ReactElement => {
  const location = useLocation();
  const { data } = location.state;
  const [articleData, setArticleData] = useState<article>({
    id: data.id,
    title: data.title,
    content: data.content,
    active: data.active,
    cat_id: data.cat_id,
    isDirty: false,
  });
  const [imgeData, setImageData] = useState<image[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isImageUploading, setIsImageUploading] = useState(false);

  const handleInputChange = (event: { target: { name: any; value: any } }) => {
    const { name, value } = event.target;
    setArticleData({
      ...articleData,
      [name]: getValue(name, value, articleData.active),
      isDirty: true,
    });
  };

  const navigate = useNavigate();
  const goToMainDashboard = () => navigate("/Dashboard");

  const handleSave = async () => {
    const response = await saveArticle(articleData);
    if (response?.data?.status === "updated") {
      goToMainDashboard(); // regresar al dashboard
    }
  };

  const handleImgActive = (id: number, active: number) => {
    updImagesActive(id, active);
    setIsLoading(true);
    setTimeout(() => getArticleImages(), 500);
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  };

  const getArticleImages = useCallback(() => {
    data.id && getAllImagesList(setImageData, data.id);
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, [data.id]);

  const renderImagesComponent = () =>
    imgeData &&
    imgeData.map((image) => {
      return (
        <Grid container spacing={1}>
          <Grid size={3}>
            ActiveTitle
            <Switch
              name="active"
              checked={Boolean(image.active)}
              onChange={() => handleImgActive(image.id, image.active)}
            />
          </Grid>
          <Grid size={8}>
            <Card>
              <img
                style={
                  image.active
                    ? { width: "80%" }
                    : { width: "80%", opacity: "50%" }
                }
                src={`data:image/png;base64,${atob(image.content)}`}
                alt={image.name}
              />
            </Card>
          </Grid>
        </Grid>
      );
    });

  useEffect(() => {
    getArticleImages();
  }, [getArticleImages]);
  return isEmpty(data) ? (
    <p>Not found</p>
  ) : (
    <>
      <div
        style={{ maxWidth: "900px", minWidth: "380px", marginInline: "auto" }}
      >
        <Card
          sx={[
            {
              width: "auto",
              textDecoration: "underline",
            },
          ]}
        >
          <form>
            <Typography variant="h3">Editing Article</Typography>
            <Grid container spacing={1}>
              <Grid size={3}>
                <Item>Title</Item>
              </Grid>
              <Grid size={9}>
                <TextField
                  variant="standard"
                  fullWidth={true}
                  id="title"
                  name="title"
                  value={articleData.title}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid size={3}>
                <Item>Category</Item>
              </Grid>
              <Grid size={9}>
                <TextField
                  select
                  name="cat_id"
                  value={articleData.cat_id}
                  onChange={handleInputChange}
                  fullWidth
                  SelectProps={{ native: true }}
                >
                  <option value="">-- Select Category --</option>
                  <option value={1}>RENT AN INFLATABLE</option>
                  <option value={2}>BUY AN INFLATABLE</option>
                  <option value={3}>RENT PARTY EQUIPMENT</option>
                </TextField>
              </Grid>

              <Grid size={3}>
                <Item>Content</Item>
              </Grid>
              <Grid size={9}>
                <TextField
                  id="content"
                  name="content"
                  label="Article Content"
                  multiline
                  fullWidth={true}
                  rows={5}
                  onChange={handleInputChange}
                  value={articleData.content}
                  defaultValue="Enter Data here"
                />
              </Grid>
              <Grid size={6}>
                <Item>Images</Item>
              </Grid>
              <Grid size={6}>
                <Item>
                  Active:{" "}
                  <Switch
                    name="active"
                    checked={articleData.active}
                    onChange={handleInputChange}
                  />
                </Item>
              </Grid>
              <Grid size={4}>
                <Item>New Image</Item>
              </Grid>
              <Grid size={4}>
                <ArticleImagesUploader
                  articleId={articleData.id}
                  setIsImageUploading={setIsImageUploading}
                  refresh={getArticleImages}
                />
                {isImageUploading && <LoadingSpinner />}
              </Grid>
              <Grid size={12}>
                {isLoading ? <LoadingSpinner /> : renderImagesComponent()}
              </Grid>
              <Grid size={6} />
              <Grid size={3}>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => goToMainDashboard()}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid size={3}>
                <Button
                  variant="contained"
                  color="success"
                  disabled={!articleData.isDirty}
                  onClick={handleSave}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </form>
        </Card>
      </div>
    </>
  );
};

export default EditArticles;
